import { Controller } from '@hotwired/stimulus'
import AJAX from 'utils/ajax'
import { showElement } from "utils/toggle_element_visibility"

export default class extends Controller {
  static targets = ["priceMessage", "price"]
  static values = {
    upcomingPaymentUrl: String,
    displayUpcomingPayment: Boolean
  }

  async displayUpcomingCharge() {
    if(this.displayUpcomingPaymentValue) {
      const response = await AJAX.get(this.upcomingPaymentUrlValue)
      const data = await response.json()
      const chargedAmount = data.amount / 100.0

      if (chargedAmount > 0) {
        this.priceTargets.forEach((trg) => (trg.innerHTML = `$${chargedAmount.toFixed(2)}`))
      } else if (this.hasPriceMessageTarget) {
        this.priceMessageTarget.innerHTML = "You have no outstanding balance. You will not be charged."
      }

      if (this.hasPriceMessageTarget) {
        showElement(this.priceMessageTarget)
      }
    }
  }
}
